import CityPageTemplate from "../city-template/CityPageTemplate";
import { lovelandConfig } from "./data";

export default function LovelandPage() {
  return <CityPageTemplate config={lovelandConfig} />;
}